import http from "../http-common";
import authHeader from "./authHeader";
import { DESIGNATION_API } from "../api";
const getAllDesignations = () => {
  return http.get(`${DESIGNATION_API}`);
};

const createDesignation = (data) => {
  return http.post(`${DESIGNATION_API}`, data, { headers: authHeader() });
};

const DesignationService = {
  getAllDesignations,

  createDesignation,
};

export default DesignationService;
